import React, { useEffect, useState } from "react";

const KceStaff = () => {
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    fetch('/data/kcestaff.json') // ✅ works at root 
      .then((res) => res.json())
      .then((data) => setStaff(data))
      .catch((err) => console.error("Error loading staff:", err));
  }, []);

  return (
    <section className="container py-5">
      <h2 className="text-center mb-4  text-warning">
        <span className="text-success">TEACHING </span> STAFF
      </h2>

      <div className="table-responsive">
        <table className="table table-bordered table-striped align-middle text-center">
          <thead className="table-success">
            <tr>
              <th>Photo</th>
              <th>Name</th>
              <th>Qualification</th>
              <th>Designation</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((member, index) => (
              <tr key={index}>
                <td>
                  <img
                    src={`${member.photo}`} // ✅ future proof
                    alt={member.name}
                    className="img-thumbnail"
                    style={{
                        width: "100%",
                        maxWidth: "200px",  // ✅ limit max size
                        height: "auto",     // ✅ keeps aspect ratio
                        objectFit: "cover", // ✅ crops neatly
                      }}
                  />
                </td>
                <td className="align-middle text-center"><strong>{member.name}</strong></td>
                <td className="align-middle text-center">{member.qualification}</td>
                <td className="align-middle text-center">{member.designation}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default KceStaff;
